import { MailCheck } from "lucide-react";
import { Button } from "../ui";
import { AuthBadge, FormError, TextButton } from "./AuthLayout";

export interface CheckEmailProps {
  email: string;
  /** What the link does: "sign in" or "choose a new password". */
  purpose: string;
  onResend: () => void;
  resending: boolean;
  resent: boolean;
  error?: string;
  onChangeEmail: () => void;
}

/**
 * PRD screen 14a, and the same for a reset link. It says "if there's an account" because the
 * server answers the same either way: the page mustn't reveal who is a customer.
 */
export function CheckEmail({ email, purpose, onResend, resending, resent, error, onChangeEmail }: CheckEmailProps) {
  return (
    <>
      <AuthBadge icon={MailCheck} />
      <h1 className="mb-4 type-h1 [font-size:var(--text-2xl)] tracking-tight">Check your email</h1>
      <p className="mb-7 type-body text-text-body">
        If <strong className="type-sku [font-size:var(--text-base)] text-text-strong">{email.trim().toLowerCase()}</strong> has an account, we've sent it a link to{" "}
        {purpose}. The link works once and expires in 15 minutes.
      </p>
      <Button type="button" fullWidth size="lg" variant="outline" disabled={resending} onClick={onResend}>
        {resending ? "Sending…" : "Send it again"}
      </Button>
      {resent && !error && (
        <p role="status" className="mt-3 mb-0 type-small text-success-700">
          Sent again. Only the newest link works.
        </p>
      )}
      <FormError>{error}</FormError>
      <p className="mt-6 mb-0 type-small text-text-muted">
        Nothing arrived? Check your spam folder, or <TextButton onClick={onChangeEmail}>use a different email</TextButton>.
      </p>
    </>
  );
}
